import styled from "styled-components";

const LeaveManagementSc = styled.div`
  margin: 10px;
  padding: 5px;
  height: 90vh;
  border-radius: 10px;
  /* fallback for old browsers */
  width: 100vw;
  /* Chrome 10-25, Safari 5.1-6 */
  position: absolute;
  top: 45px;
  .leave-approval-navbar {
    position: fixed;
  }

  .individual-page {
    width: 95vw;
    height: 100vh;
    padding: 1.2em;
  }
  .leave-main {
    max-width: 100%;
  }
  .leave-approval-name-card {
    display: flex;
    gap: 20px;

    justify-content: center;
    align-items: center;
  }

  .leave-approval-card {
    display: flex;
    justify-content: space-between;
    padding: 1rem;
  }
  .date {
    padding: 25px;
  }

  .date1 {
    width: 36%;
    padding: 5px;
    margin: 10px 0;
  }

  .leave-approval-emp-image {
    width: 80px;
  }

  .leave-detail-side {
    background-color: #ffffff;
    box-shadow: black;
    width: 100;
    border: solid rgba(151, 150, 150, 0.192);
    padding: 50px;
    margin: 20px;
    display: flex;
    justify-content: space-around;
    text-align: center;
    border-radius: 5px;
  }

  .total-leave {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
  }

  .leave-consumed {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
  }

  .leave-balance {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
  }

  .total-leave-number {
    background-color: #1e59d9;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
  }
  .leave-status {
    background-color: #11dd32;
    width: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10%;
  }
  .leave-status-title {
    width: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10%;
  }
  .leave-button {
    padding: 20px;
    margin: 20px;
    margin: 20px;
    display: flex;
    align-self: flex-end;
  }
  .apply-button {
    display: flex;
    justify-content: flex-end;
  }
  .consumed-leave-number {
    background-color: #dd1e11;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
  }

  .balance-leave-number {
    background-color: #11dd32;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
  }

  .request-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 10px;
  }

  .request-box > div {
    padding-left: 10px;
  }
  .request-conatiner-title {
    padding: 30px;
    width: 90vw;
    display: flex;
    justify-content: space-between;
    align-items: center;

    border-radius: 8px;
  }
  .leave-request-conatiner {
    background-color: #ffffff;
    box-shadow: 0px 0px 8px 5px rgba(0, 0, 0, 0.4);
    padding: 30px;
    width: 90vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 30px;
    border-radius: 8px;
  }

  .leave-wfh-container {
    width: 100vw;

    padding: 18px 10px;
    color: black;
    display: flex;
    flex-direction: column;
  }

  .leave-wfh-title {
    display: flex;
    justify-content: space-between;
  }

  .leave-wfh-details-list {
    display: flex;

    justify-content: space-between;
    background-color: white;
    text-align: center;
    margin: 5px;
    width: 92vw;
    height: 30px;
    padding: 5px;
    border-radius: 3px;
  }

  .approve-page {
    display: flex;
    height: 100vh;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .App h1 {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  body {
    padding: 0;
    margin: 0;
  }

  .App .openModalBtn {
    margin-left: 32px;
    width: 200px;
    height: 40px;
    border: none;
    border-radius: 6px;
    background-color: cornflowerblue;
    color: white;
    cursor: pointer;
  }
  .leave-card {
    display: flex;
    justify-content: space-between;
  }
  .leave-date {
    padding-right: 30px;
  }
  .leave-type {
    padding-right: 20px;
  }

  .leave-reason {
    padding-right: 20px;
  }
  .leave-from-date {
    padding-right: 20px;
  }
  .leave-to-date {
    padding-right: 20px;
  }
  table {
    font-family: arial, sans-serif;
    width: 100%;
    margin: 30px auto;
    max-width: 90vw;
    background-color: #fff;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    border-collapse: collapse;
  }

  th {
    background-color: #4285f4;
    color: #fff;
    border: 1px solid #4285f4;
    text-align: center;
    padding: 12px;
  }

  .heading {
    text-align: center;
  }

  td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;
  }

  tr:nth-child(even) {
    background-color: #f2f2f2;
  }

  th:hover {
    background-color: #3367d6;
  }

  tr:hover td {
    background-color: #e4f0fb;
  }
  .leave-details-container-user {
    display: flex;
    gap: 3rem;
  }
  .total-leave-conatiner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: linear-gradient(
      95deg,
      rgba(240, 184, 184, 1) 3%,
      rgba(255, 157, 171, 1) 40%
    );
    padding: 2rem 3rem;
    color: white;
    border-radius: 1rem;
    font-size: medium;
    max-width: 300px;
    width: 240px;
    font-weight: 600;
  }
  .consumed-leave-container {
    background: linear-gradient(
      95deg,
      rgba(96, 176, 240, 1) 12%,
      rgba(18, 111, 186, 1) 65%
    );
    padding: 2rem 3rem;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 1rem;
    font-size: medium;
    max-width: 300px;
    width: 240px;
    font-weight: 600;
  }
  .available-leave-container {
    background: -webkit-linear-gradient(
      95deg,
      rgb(179, 122, 194) 0%,
      rgba(155, 107, 205, 1) 53%
    );
    padding: 2rem 3rem;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 1rem;
    max-width: 300px;
    width: 240px;
    font-size: medium;
    font-weight: 600;
  }
  @media (max-width: 840px) {
    .leave-approval-card {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 1rem;
    }
    .leave-details-container-user {
      display: flex;
      flex-direction: column;
      gap: 3rem;
    }
    .leave-main {
      display: flex;
      padding: 0.5rem;
    }
  }
`;

export default LeaveManagementSc;
